export { setFeatures, setMvtParams } from "./actions";
import { SET_FEATURES, SET_MVT_PARAMS } from "./constants";
import {
  RECS_ON_CATEGORY_PLPS,
  RECS_ON_SEARCH_PLPS
} from "../../../server/recs/constants";

const initialState = {
  experimentEligibility: {
    [RECS_ON_CATEGORY_PLPS]: false,
    [RECS_ON_SEARCH_PLPS]: false
  }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_FEATURES:
      return {
        ...state,
        ...action.payload
      };
    case SET_MVT_PARAMS: {
      const {
        experiment = {},
        params: { ...mvtParams }
      } = action.payload;

      return {
        ...state,
        mvtParams,
        experimentEligibility: {
          ...state.experimentEligibility,
          ...experiment
        }
      };
    }
    default:
      return state;
  }
};
